import { Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { BadgeStatusPrListInbounds } from '../../../../components/atoms/StatusLabel'
import Breadcrumb from '../../../../components/Label/Breadcrumb'
import ActionButton from '../../Plan/ActionButton'
import CustomButton from '../../../../components/Button/CustomButton'
import { headerTitleStyle } from './constants'

const DetailHeader = ({
  detail,
  searchParams,
  submitSolveContinueTicket,
  setShowModalSolveContinueTicket,
  handleSubmitSolveContinueTicket,
  loadingDownloadPrint,
  handleDownloadPrint,
  setShowModalSelectFormat,
  setSelectFormatDownload
}) => {
  return (
    <>
      <Col md={5} className="mt-3">
        {!searchParams.get('outboundId') && (
          <Breadcrumb
            label={detail?.draft_code}
            link="/outbound/sj"
            back="SJDRAFT"
            type="BadgeStatusPrListInbounds"
            status={detail.draft_status}
          />
        )}
        {searchParams.get('outboundId') && searchParams.get('outboundCode') && (
          <>
            <h4 style={headerTitleStyle}>
              {detail?.draft_code}{' '}
              <sup style={{ fontSize: '12px', marginLeft: '5px' }}>
                {<BadgeStatusPrListInbounds text={detail.draft_status} />}
              </sup>
            </h4>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item sj-item">
                  <Link to={'/outbound/plan'} className="text-decoration-none">
                    <span className="text-black fw-bold text-uppercase">
                      Outbound
                    </span>
                  </Link>
                </li>
                <li className="breadcrumb-item sj-item">
                  <Link
                    to={`/outbound/plan/detail/${searchParams.get(
                      'outboundId'
                    )}`}
                    className="text-decoration-none"
                  >
                    <span className="text-black fw-bold text-uppercase">
                      {searchParams.get('outboundCode')}
                    </span>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item sj-item active"
                  aria-current="page"
                >
                  {detail?.draft_code}
                </li>
              </ol>
            </nav>
          </>
        )}
      </Col>

      <ActionButton column={7}>
        <div style={{ marginTop: '2.3rem' }} className="d-flex flex-row gap-2">
          {detail?.is_cross_dock && (
            <CustomButton
              variant={'transparent'}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                fontWeight: 'bold'
              }}
              classNameValue="text-danger"
              text={'Cross Dock'}
              disabled
            />
          )}
          {/* button action solve when status sj problem */}
          {detail.draft_status === 'problem' && (
            <CustomButton
              variant={'transparent'}
              style={{ backgroundColor: '#F89D1D' }}
              text={'Solve problem and continue ticket'}
              disabled={submitSolveContinueTicket}
              onClick={() =>
                detail?.pickup_command?.reduce(
                  (acc, cur) =>
                    (acc +=
                      cur.qty -
                      (cur.report_pack
                        ? cur.report_pack * cur.convertion_factor_pack
                        : 0)),
                  0
                ) !== detail?.command?.reduce((acc, cur) => (acc += cur.qty), 0)
                  ? setShowModalSolveContinueTicket(true)
                  : handleSubmitSolveContinueTicket()
              }
            />
          )}
          {detail?.draft_status !== 'problem' &&
            detail?.draft_status === 'ongoing' && (
              <>
                <CustomButton
                  variant={'transparent'}
                  style={{ backgroundColor: '#F89D1D' }}
                  text={
                    loadingDownloadPrint.coaDownload
                      ? 'Downloading...'
                      : 'Download C.O.A'
                  }
                  onClick={() =>
                    handleDownloadPrint('coa', 'download', detail?.id)
                  }
                />
                <CustomButton
                  variant={'transparent'}
                  style={{ backgroundColor: '#203568' }}
                  text={
                    loadingDownloadPrint.coaPrint
                      ? 'Downloading...'
                      : 'Print C.O.A'
                  }
                  onClick={() =>
                    handleDownloadPrint('coa', 'print', detail?.id)
                  }
                />
              </>
            )}
          {detail?.draft_status !== 'problem' &&
            ['submit', 'done'].some(
              (status) => detail?.draft_status === status
            ) && (
              <>
                <CustomButton
                  variant={'transparent'}
                  style={{ backgroundColor: '#F89D1D' }}
                  text={
                    loadingDownloadPrint.sjDownload
                      ? 'Downloading...'
                      : 'Download SJ'
                  }
                  onClick={() => {
                    setShowModalSelectFormat(true)
                    setSelectFormatDownload((prevSelectFormatDownload) => ({
                      ...prevSelectFormatDownload,
                      id: detail?.id,
                      action: 'download'
                    }))
                  }}
                />
                <CustomButton
                  variant={'transparent'}
                  style={{ backgroundColor: '#203568' }}
                  text={
                    loadingDownloadPrint.sjPrint ? 'Downloading...' : 'Print SJ'
                  }
                  onClick={() => {
                    setShowModalSelectFormat(true)
                    setSelectFormatDownload((prevSelectFormatDownload) => ({
                      ...prevSelectFormatDownload,
                      id: detail?.id,
                      action: 'print'
                    }))
                  }}
                />
              </>
            )}
        </div>
      </ActionButton>
    </>
  )
}

export default DetailHeader
